import payperiodList from "emun.commissioning/payperiods/payperiod-list";
import vendorInvoiceList from "emun.commissioning/invoices/vendor-invoice-list";
import { extendModule } from "ng";

const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export default angular
  .module("emun.commissioning", deps)
  .component("payperiodList", payperiodList)
  .component("vendorInvoiceList", vendorInvoiceList)
  .name;

